import { useNavigate } from 'react-router-dom';
import { Heading, BodyText, Button } from '@aaimplatform/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="text-center mt-16">
      {/* Level 2: this is the catch-all inside PortalLayout, whose AppHeader
          renders the page h1 (operator ruling on GH #2664, 2026-08-20). */}
      <Heading level={2} size="page" className="font-sans mb-4">404 - Page Not Found</Heading>
      <BodyText className="text-secondary mb-6">
        The page you are looking for does not exist.
      </BodyText>
      <Button variant="primary" onClick={() => navigate('/')}>
        Go to Dashboard
      </Button>
    </div>
  );
}
